import { render, staticRenderFns } from "./PaymentDetailsReportTable.vue?vue&type=template&id=a645d518"
import script from "./PaymentDetailsReportTable.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports